import config from '__api/config';
import { zqhdApi } from '__api/zqhd/creatZqhdRequest';

/* 完成任务 */
type FinishTaskRequest = {
  taskId: string; //任务ID
};
interface FinishTaskRes {
  status: string; // 状态 1：成功 2：任务不存在 3: 任务已完成 4: 邀请跳转链接获取成功 5：邀请跳转链接获取失败 6： 服务繁忙
  inviteUrl: string; // 邀请链接地址
  success: boolean;
  code: number;
  message: string;
}
/*完成任务*/
export async function finishTask(request: FinishTaskRequest) {
  const url = config.zqhpLink + '/activity/competition-welfare/finishTask';
  return zqhdApi.fetch<FinishTaskRes>(url, request);
}
